import React from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/PostDetail.css";

function scrollUp() {
  let currentScroll = document.documentElement.scrollTop;
  if (currentScroll > 0) {
    window.requestAnimationFrame(scrollUp);
    window.scrollTo(0, currentScroll - currentScroll / 27);
  }
}

const PostDetail = ({ posts }) => {
  let recomendedPosts = posts
    .sort(() => Math.random() - Math.random())
    .slice(0, 3);

  const { postId } = useParams();
  const post = posts.find((post) => post.id === postId);

  return (
    <div className="post-detail">
      {post && (
        <article className="post">
          <h2>{post.title}</h2>
          <div className="post-contentTitle">
            <p className="post-contentSummary">{post.content.contentSummary}</p>
            {post.content.contentSummaryExended && (
              <p className="post-contentSummary">
                {post.content.contentSummaryExended}
              </p>
            )}
            {post.content.contentAnnunce && (
              <p className="post-contentAnnunce">
                {post.content.contentAnnunce}
              </p>
            )}
            <img
              src={post.imageTitle}
              alt={post.postId}
              className="post-photoD"
            />
          </div>
          <div className="post-container">
            {post.content && (
              <div className="post-content">
                {post.content.contentBody.map((content) => (
                  <div key={content.contentTitle} className="post-content-box">
                    <h3 key={postId}>{content.contentTitle}</h3>
                    {content.contentParagraph && (
                      <div key={content.contentParagraph}>
                        {content.contentParagraph.map((paragraph) =>
                          Array.isArray(paragraph) ? (
                            <a
                              href={paragraph[0].paragraphLink}
                              key={paragraph[0].paragraphLink}
                              className="afiliateLink"
                            >
                              {paragraph[1].paragraph}
                            </a>
                          ) : (
                            <p key={paragraph.paragraph}>
                              {paragraph.paragraph}
                            </p>
                          )
                        )}
                      </div>
                    )}
                    {content.afiliateLink && (
                      <a
                        className="afiliateLink"
                        href={content.afiliateLink.link}
                        key={content.afiliateLink.paragraph}
                      >
                        {content.afiliateLink.paragraph}
                      </a>
                    )}
                    {content.afiliateLink2 && (
                      <a
                        className="afiliateLink"
                        href={content.afiliateLink2.link}
                        key={content.afiliateLink2.paragraph}
                      >
                        {content.afiliateLink2.paragraph}
                      </a>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="post-info">
            <p className="author">By {post.author}</p>
            <p className="date">{post.date}</p>
          </div>
        </article>
      )}
      <div className="recommended-posts">
        <h3>Recommended Posts</h3>
        <div className="recommended-list">
          {recomendedPosts.map((recommendedPost) => (
            <div key={recommendedPost.id} className="recommended-post">
              <h4>{recommendedPost.title}</h4>
              <p>
                {recommendedPost.content.contentSummary.substring(0, 80)}...
              </p>
              <Link to={`/post/${recommendedPost.id}`} onClick={scrollUp}>
                Read More
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostDetail;
